<template>
  <div class="home-page">
    <!-- ===== 英雄区 (bg01.png) - 去掉右侧 GPU 卡片 ===== -->
    <section class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-container hero-center-layout">
        <div class="hero-left">
          <!-- <div class="hero-badge">
            <span class="badge-dot"></span>
            下一代旗舰算力
          </div> -->
          <h1 class="hero-title">
            <span class="highlight">{{ $t("home.heroTitle1") }}</span>
            <br />
            {{ $t("home.heroTitle2") }}
          </h1>
          <p class="hero-subtitle"></p>
          <p class="hero-desc">
            {{ $t("home.heroDesc") }}
          </p>
          <div class="hero-actions">
            <button class="btn btn-glow" @click="handleStartClick">
              {{ $t("home.heroBtn") }}
            </button>
            <!-- <span class="hero-price">月付 ¥2999 起</span> -->
          </div>
          <div class="hero-stats">
            <div class="stat-item">
              <span class="stat-number">10亿+</span>
              <span class="stat-label">{{ $t("home.statTrade") }}</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">99.9%</span>
              <span class="stat-label">{{ $t("home.statReliability") }}</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">100+</span>
              <span class="stat-label">{{ $t("home.statGlobal") }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 全球节点 (bg02.png) ===== -->
    <TokenList />

    <!-- 服务器租赁 -->
    <ServerList />

    <!-- ===== 🆕 用户结算动态轮播（合作钱包上方，吸底效果） ===== -->
    <div class="settlement-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ $t("home.settleTitle1")
          }}<span class="highlight">{{ $t("home.settleTitle2") }}</span>
        </h2>
        <p class="section-desc">{{ $t("home.settleDesc") }}</p>
      </div>
    </div>
    <SettlementCarousel />

    <!-- ===== 机房建设板块 ===== -->
    <section class="build-section">
      <div class="build-bg">
        <div class="build-orb build-orb-1"></div>
        <div class="build-orb build-orb-2"></div>
        <div class="build-orb build-orb-3"></div>
      </div>
      <div class="build-container">
        <div class="build-content">
          <!-- 左侧文字 -->
          <div class="build-text">
            <!-- <span class="section-badge">🏗️ 自建机房</span> -->
            <h2 class="build-title">
              {{ $t("home.buildTitle1")
              }}<span class="highlight">{{ $t("home.buildTitle2") }}</span>
            </h2>
            <p class="build-desc">
              {{ $t("home.buildDesc1") }}<br />
              <strong class="build-highlight-text">{{
                $t("home.buildDesc2")
              }}</strong>
            </p>

            <div class="build-features">
              <div class="build-feature">
                <div class="build-feature-icon">🔑</div>
                <div>
                  <h4>{{ $t("home.buildFeature1Title") }}</h4>
                  <p>{{ $t("home.buildFeature1Desc") }}</p>
                </div>
              </div>
              <div class="build-feature">
                <div class="build-feature-icon">📊</div>
                <div>
                  <h4>{{ $t("home.buildFeature2Title") }}</h4>
                  <p>{{ $t("home.buildFeature2Desc") }}</p>
                </div>
              </div>
              <div class="build-feature">
                <div class="build-feature-icon">⚙️</div>
                <div>
                  <h4>{{ $t("home.buildFeature3Title") }}</h4>
                  <p>{{ $t("home.buildFeature3Desc") }}</p>
                </div>
              </div>
              <div class="build-feature">
                <div class="build-feature-icon">💰</div>
                <div>
                  <h4>{{ $t("home.buildFeature4Title") }}</h4>
                  <p>
                    {{ $t("home.buildFeature4Desc") }}
                  </p>
                </div>
              </div>
            </div>

            <button class="btn btn-build" @click="handleBuild">
              {{ $t("home.buildBtn") }}
              <span class="btn-build-glow"></span>
            </button>
          </div>

          <!-- 右侧数据卡片 -->
          <div class="build-stats-card">
            <div class="build-stats-header">
              <span class="build-stats-title"
                >📈 {{ $t("home.buildStatsTitle") }}</span
              >
              <span class="build-stats-update">{{
                $t("home.buildStatsUpdate")
              }}</span>
            </div>

            <div class="build-stat-item">
              <span class="build-stat-label">{{
                $t("home.buildStatRooms")
              }}</span>
              <span class="build-stat-number">128</span>
            </div>
            <div class="build-stat-item">
              <span class="build-stat-label">{{
                $t("home.buildStatServers")
              }}</span>
              <span class="build-stat-number">2,847</span>
            </div>
            <div class="build-stat-item">
              <span class="build-stat-label">{{
                $t("home.buildStatProfit")
              }}</span>
              <span class="build-stat-number build-stat-profit">$48.6M</span>
            </div>
            <div class="build-stat-item">
              <span class="build-stat-label">{{
                $t("home.buildStatPayback")
              }}</span>
              <span class="build-stat-number"
                >6.8
                <span
                  style="font-size: 14px; color: rgba(255, 255, 255, 0.3)"
                  >{{ $t("home.buildStatMonth") }}</span
                ></span
              >
            </div>

            <div class="build-stat-divider"></div>

            <div class="build-cta-mini">
              <span>{{ $t("home.buildCta") }}</span>
              <button class="btn btn-build-mini" @click="handleBuild">
                {{ $t("home.buildCtaBtn") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 功能特性 ===== -->
    <section class="features-section">
      <div class="section-header">
        <span class="section-badge">{{ $t("home.featuresBadge") }}</span>
        <h2 class="section-title">
          {{ $t("home.featuresTitle1")
          }}<span class="highlight">{{ $t("home.featuresTitle2") }}</span>
        </h2>
      </div>
      <div class="features-grid">
        <div class="feature-card">
          <div
            class="feature-icon"
            style="background: linear-gradient(135deg, #f7971e, #ffd200)"
          >
            ⚡
          </div>
          <h3 class="feature-title">{{ $t("home.feature1Title") }}</h3>
          <p class="feature-desc">{{ $t("home.feature1Desc") }}</p>
        </div>
        <div class="feature-card">
          <div
            class="feature-icon"
            style="background: linear-gradient(135deg, #00b4ff, #0066ff)"
          >
            🛡️
          </div>
          <h3 class="feature-title">{{ $t("home.feature2Title") }}</h3>
          <p class="feature-desc">{{ $t("home.feature2Desc") }}</p>
        </div>
        <div class="feature-card">
          <div
            class="feature-icon"
            style="background: linear-gradient(135deg, #7c3aed, #4f46e5)"
          >
            🚀
          </div>
          <h3 class="feature-title">{{ $t("home.feature3Title") }}</h3>
          <p class="feature-desc">{{ $t("home.feature3Desc") }}</p>
        </div>
        <div class="feature-card">
          <div
            class="feature-icon"
            style="background: linear-gradient(135deg, #00c951, #00a83e)"
          >
            🌍
          </div>
          <h3 class="feature-title">{{ $t("home.feature4Title") }}</h3>
          <p class="feature-desc">{{ $t("home.feature4Desc") }}</p>
        </div>
      </div>
    </section>

    <!-- ===== 🆕 APP 应用下载板块 ===== -->
    <section class="app-download-section">
      <div class="app-download-bg">
        <div class="app-orb app-orb-1"></div>
        <div class="app-orb app-orb-2"></div>
      </div>
      <div class="app-download-container">
        <!-- 左侧文字 -->
        <div class="app-text">
          <span class="section-badge">📱 {{ $t("home.appBadge") }}</span>
          <h2 class="app-title">
            <!-- 随时随地，<br /> -->
            <span class="highlight">{{ $t("home.appTitle") }}</span>
          </h2>
          <p class="app-desc">
            {{ $t("home.appDesc1") }}<br />
            {{ $t("home.appDesc2") }}<br />
            {{ $t("home.appDesc3") }}
          </p>
          <!-- 二维码 + 下载按钮 -->
          <div class="app-download-actions">
            <div class="app-qr">
              <img
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Crect width='120' height='120' fill='%23ffffff'/%3E%3Crect x='10' y='10' width='30' height='30' fill='%23000000'/%3E%3Crect x='50' y='10' width='30' height='30' fill='%23000000'/%3E%3Crect x='10' y='50' width='30' height='30' fill='%23000000'/%3E%3Crect x='50' y='50' width='20' height='20' fill='%23000000'/%3E%3Crect x='80' y='10' width='30' height='30' fill='%23000000'/%3E%3Crect x='10' y='90' width='30' height='20' fill='%23000000'/%3E%3Crect x='50' y='80' width='30' height='30' fill='%23000000'/%3E%3Crect x='90' y='50' width='20' height='30' fill='%23000000'/%3E%3C/svg%3E"
                :alt="$t('home.altQr')"
              />
            </div>
            <div class="app-store-buttons">
              <span class="app-qr-text">{{ $t("home.appQrText") }}</span>
              <div class="store-buttons">
                <button class="btn-store">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                    />
                  </svg>
                  App Store
                </button>
                <button class="btn-store">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M3.75 2.25L3 2.77v18.46l.75.52L14.09 12 3.75 2.25zM4.5 19.43V4.57L12.77 12 4.5 19.43zM15.75 2.25L15 2.77v18.46l.75.52L21 12l-5.25-9.75zM16.5 19.43V4.57L20.27 12l-3.77 7.43z"
                    />
                  </svg>
                  Google Play
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧 App 截图 -->
        <div class="apptp">
          <img
            src="../assets/imgs/jqqd2.png"
            :alt="$t('home.altApp')"
            @error="handleImageError"
          />
        </div>
        <!-- <div class="app-screenshot">
          <div class="phone-mockup">
            <img
              src="../assets/imgs/jqqd.png"
              alt="App 截图"
              @error="handleImageError"
            />
            <div class="phone-notch"></div>
          </div>
        </div> -->
      </div>
    </section>

    <!-- ===== 🆕 合作钱包板块 ===== -->
    <section class="wallets-section">
      <div class="section-header">
        <!-- <span class="section-badge">🔗 生态合作</span> -->
        <h2 class="section-title">
          {{ $t("home.walletsTitle1")
          }}<span class="highlight">{{ $t("home.walletsTitle2") }}</span>
        </h2>
        <p class="section-desc">{{ $t("home.walletsDesc") }}</p>
      </div>
      <div class="wallets-grid">
        <div
          class="wallet-card"
          v-for="wallet in wallets"
          :key="wallet.name"
          :class="{ 'wallet-highlight': wallet.highlight }"
          @click="handleClick(wallet)"
        >
          <div class="wallet-icon">
            <!-- <img :src="wallet.icon" :alt="wallet.name" v-if="wallet.icon" /> -->
            <span style="width: 70px; height: 70px">
              <img :src="wallet.emoji" :alt="$t('home.altWallet')" />
            </span>
          </div>
          <span class="wallet-name">{{ wallet.name }}</span>
          <!-- <span v-if="wallet.highlight" class="wallet-badge">最佳钱包</span> -->
        </div>
      </div>
    </section>

    <!-- ===== CTA 区 ===== -->
    <!-- <section class="cta-section">
      <div class="cta-bg">
        <div class="cta-orb cta-orb-1"></div>
        <div class="cta-orb cta-orb-2"></div>
      </div>
      <div class="cta-content">
        <span class="cta-badge">🚀 立即开始</span>
        <h2 class="cta-title">
          立即开始您的 <span class="highlight">AI之旅</span>
        </h2>
        <p class="cta-desc">
          加入超过 50,000 名开发者，体验极致 GPU 云算力。<br />注册即享 7
          天免费试用。
        </p>
        <div class="cta-actions">
          <button class="btn btn-cta">免费注册账号 →</button>
          <span class="cta-note">无需信用卡 · 随时取消</span>
        </div>
      </div>
    </section> -->

    <!-- ===== 机房建设弹框 ===== -->
    <transition name="modal-fade">
      <div
        v-if="showBuildModal"
        class="build-modal-overlay"
        @click.self="closeBuildModal"
      >
        <div class="build-modal">
          <button class="build-modal-close" @click="closeBuildModal">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <div class="build-modal-icon">🏗️</div>
          <h3 class="build-modal-title">{{ $t("home.modalTitle") }}</h3>
          <p class="build-modal-desc">
            {{ $t("home.modalDesc1") }}<br />
            {{ $t("home.modalDesc2") }}
          </p>
          <button class="build-modal-btn" @click="closeBuildModal">
            {{ $t("home.modalBtn") }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TokenList from "@/components/home/TokenList.vue";
import ServerList from "@/components/home/ServerList.vue";
import SettlementCarousel from "@/components/home/SettlementCarousel.vue";

export default {
  name: "HomePage",
  components: {
    TokenList,
    ServerList,
    SettlementCarousel,
  },
  data() {
    return {
      // ===== 弹框状态 =====
      showBuildModal: false,

      // ===== 🆕 加密货币数据（APP板块） =====
      cryptos: [
        {
          name: "BNB",
          change: "+2.31%",
          changeClass: "change-up",
          price: "$1083.47",
        },
        {
          name: "Bitcoin",
          change: "+2.22%",
          changeClass: "change-up",
          price: "$124,474.00",
        },
        {
          name: "Ethereum",
          change: "+1.83%",
          changeClass: "change-up",
          price: "$426.08",
        },
        {
          name: "Plasma",
          change: "+7.06%",
          changeClass: "change-up",
          price: "$1.39",
        },
        {
          name: "Mira",
          change: "+46.52%",
          changeClass: "change-up",
          price: "$5.42",
        },
        {
          name: "Solana",
          change: "+4.73%",
          changeClass: "change-up",
          price: "$304.78",
        },
        {
          name: "Dogecoin",
          change: "+2.93%",
          changeClass: "change-up",
          price: "$0.42",
        },
      ],

      // ===== 🆕 钱包数据 =====
      wallets: [
        {
          name: "Binance Wallet",
          emoji: require("../assets/wallet/binance.png"),
          highlight: false,
          url: "https://binance.com/",
        },
        {
          name: "MetaMask",
          emoji: require("../assets/wallet/MetaMask.webp"),
          highlight: false,
          url: "https://metamask.io/",
        },
        {
          name: "SafePal",
          emoji: require("../assets/wallet/SafePal.webp"),
          highlight: false,
          url: "https://safepal.io/",
        },
        {
          name: "Trust Wallet",
          emoji: require("../assets/wallet/Trust Wallet.webp"),
          highlight: false,
          url: "https://trustwallet.io/",
        },
        // {
        //   name: "Fireblocks",
        //   emoji: require("../assets/wallet/Fireblocks.webp"),
        //   highlight: false,
        //   url: "https://fireblocks.io/",
        // },
        {
          name: "OKX Wallet",
          emoji: require("../assets/wallet/OKX Wallet.webp"),
          highlight: false,
          url: "https://okx.com/",
        },
        {
          name: "TokenPocket",
          emoji: require("../assets/wallet/TokenPocket.webp"),
          highlight: false,
          url: "https://tokenpocket.io/",
        },
        // {
        //   name: "Bitget Wallet",
        //   emoji: require("../assets/wallet/Bitget Wallet.webp"),
        //   highlight: false,
        //   url: "https://bitget.io/",
        // },
        {
          name: "Uniswap Wallet",
          emoji: require("../assets/wallet/Uniswap Wallet.webp"),
          highlight: false,
          url: "https://uniswap.org/",
        },
        // {
        //   name: "Ledger Wallet",
        //   emoji: require("../assets/wallet/Ledger Wallet.webp"),
        //   highlight: false,
        //   url: "https://ledger.com/",
        // },
        // {
        //   name: "Zerion",
        //   emoji: require("../assets/wallet/Zerion.webp"),
        //   highlight: false,
        //   url: "https://zerion.io/",
        // },
        {
          name: "Best Wallet",
          emoji: require("../assets/wallet/Best Wallet.webp"),
          highlight: false,
          url: "https://bestwallet.io/",
        },
        {
          name: "Crypto.com Onchain",
          emoji: require("../assets/wallet/Crypto.com Onchain.webp"),
          highlight: false,
          url: "https://crypto.com/",
        },
        {
          name: "Bifrost Wallet",
          emoji: require("../assets/wallet/Bifrost Wallet.webp"),
          highlight: false,
          url: "https://bifrost.io/",
        },
        // {
        //   name: "xPortal",
        //   emoji: require("../assets/wallet/xPortal.webp"),
        //   highlight: false,
        //   url: "https://xportal.io/",
        // },
        {
          name: "Bitcoin.com Wallet",
          emoji: require("../assets/wallet/Bitcoin.com Wallet.webp"),
          highlight: false,
          url: "https://bitcoin.com/",
        },
        {
          name: "1inch Wallet",
          emoji: require("../assets/wallet/1inch Wallet.webp"),
          highlight: false,
          url: "https://1inch.io/",
        },
        {
          name: "Trezor Suite",
          emoji: require("../assets/wallet/Trezor Suite.webp"),
          highlight: false,
          url: "https://trezor.io/",
        },
        {
          name: "Blockchain.com",
          emoji: require("../assets/wallet/Blockchain.com.webp"),
          highlight: false,
          url: "https://blockchain.com/",
        },
        {
          name: "imToken",
          emoji: require("../assets/wallet/imToken.webp"),
          highlight: false,
          url: "https://imtoken.io/",
        },
        {
          name: "BitPay Wallet",
          emoji: require("../assets/wallet/BitPay Wallet.webp"),
          highlight: false,
          url: "https://bitpay.com/",
        },
        // {
        //   name: "Gemini",
        //   emoji: require("../assets/wallet/Gemini.webp"),
        //   highlight: false,
        //   url: "https://gemini.com/",
        // },
        {
          name: "Arculus Wallet",
          emoji: require("../assets/wallet/Arculus Wallet.webp"),
          highlight: false,
          url: "https://arculus.io/",
        },
        {
          name: "Ctrl Wallet",
          emoji: require("../assets/wallet/Ctrl Wallet.webp"),
          highlight: false,
          url: "https://ctrlwallet.io/",
        },
        // { name: "TrustWallet", emoji: require("../assets/wallet/TrustWallet.webp"), highlight: false },
        // { name: "防火块", emoji: require("../assets/wallet/Firewall.webp"), highlight: false },
        // { name: "OKX钱包", emoji: require("../assets/wallet/OKXWallet.webp"), highlight: false },
        // { name: "TokenPocket", emoji: require("../assets/wallet/TokenPocket.webp"), highlight: false },
        // { name: "Bitget钱包", emoji: require("../assets/wallet/Bitget.webp"), highlight: false },
        // { name: "Uniswap钱包", emoji: require("../assets/wallet/Uniswap.webp"), highlight: false },
        // { name: "Ledger钱包", emoji: require("../assets/wallet/Ledger.webp"), highlight: false },
        // { name: "泽里昂", emoji: require("../assets/wallet/Zereon.webp"), highlight: false },
        // { name: "最佳钱包", emoji: require("../assets/wallet/best.webp"), highlight: true },
      ],
    };
  },
  methods: {
    handleClick(wallet) {
      window.open(wallet.url, "_blank");
    },
    handleStartClick() {
      this.$router.push({
        path: "/info",
      });
    },
    handleImageError(e) {
      // 如果图片加载失败，显示占位图
      e.target.src =
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="600" viewBox="0 0 300 600"%3E%3Crect width="300" height="600" fill="%231a1f35" rx="30"/%3E%3Crect x="30" y="40" width="240" height="30" rx="6" fill="%232a2f45"/%3E%3Crect x="30" y="90" width="180" height="16" rx="4" fill="%232a2f45"/%3E%3Crect x="30" y="120" width="200" height="16" rx="4" fill="%232a2f45"/%3E%3Crect x="30" y="160" width="240" height="120" rx="12" fill="%232a2f45"/%3E%3Crect x="30" y="300" width="240" height="40" rx="8" fill="%232a2f45"/%3E%3Crect x="30" y="360" width="240" height="40" rx="8" fill="%232a2f45"/%3E%3Crect x="30" y="420" width="240" height="40" rx="8" fill="%232a2f45"/%3E%3C/svg%3E';
    },

    handleRental(server) {
      console.log("租赁服务器:", server);
      // 跳转到租赁详情页或弹出对话框
      this.$router.push({
        path: "/rental",
        query: { id: server.id },
      });
    },
    handleBuild() {
      console.log("点击立即建设，弹出提示");
      this.showBuildModal = true;
    },
    closeBuildModal() {
      this.showBuildModal = false;
    },
  },
};
</script>

<style scoped>
/* ============================================================
   全局重置 & 通用
   ============================================================ */
.home-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #0a0e1a;
  color: #fff;
  /* 使用 clip 代替 hidden，避免破坏 position: sticky 效果 */
  overflow-x: clip;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 12px;
}

.section-title {
  font-size: 40px;
  font-weight: 800;
  margin: 0 0 8px 0;
}

.section-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.highlight {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ============================================================
   英雄区
   ============================================================ */
.hero-section {
  min-height: calc(100vh - 71px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: url("../assets/imgs/bg001.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 14, 26, 0.6);
  z-index: 0;
}

.hero-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
  text-align: center;
}

.hero-center-layout {
  display: flex;
  justify-content: center;
}

.hero-left {
  max-width: 800px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 20px;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00b4ff;
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.hero-title {
  font-size: 64px;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 8px 0;
}

.hero-subtitle {
  font-size: 24px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 16px 0;
  letter-spacing: 4px;
}

.hero-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  max-width: 600px;
  margin: 0 auto 32px;
}

.hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.btn-glow {
  padding: 14px 32px;
  border-radius: 12px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
  overflow: hidden;
}

.btn-glow::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s;
}

.btn-glow:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 100, 255, 0.4);
}

.btn-glow:hover::before {
  opacity: 1;
}

.hero-price {
  font-size: 20px;
  font-weight: 700;
  color: #ffd866;
}

.hero-stats {
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.08);
}

/* ============================================================
   功能特性
   ============================================================ */
.features-section {
  padding: 80px 20px;
  background: #0a0e1a;
}

.features-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-6px);
  border-color: rgba(0, 180, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
}

.feature-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 16px;
}

.feature-title {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.feature-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  margin: 0;
}

/* ============================================================
   🆕 APP 应用下载板块
   ============================================================ */
.app-download-section {
  padding: 80px 20px 0 20px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0e1a, #0d1a2b);
}

.app-download-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.app-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.15;
}

.app-orb-1 {
  width: 500px;
  height: 500px;
  background: #00b4ff;
  top: -200px;
  left: -100px;
}

.app-orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -150px;
  right: -100px;
}

.app-download-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

/* 左侧文字 */
.app-text {
  flex: 1;
}

.app-title {
  font-size: 44px;
  font-weight: 800;
  line-height: 1.2;
  margin: 12px 0 16px 0;
}

.app-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin-bottom: 28px;
}

.app-qr-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.app-qr {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 16px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.app-qr img {
  width: 100%;
  height: 100%;
  display: block;
}

.app-qr-text {
  display: flex;
  flex-direction: column;
}

.app-qr-text span {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.app-qr-text small {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

/* 右侧价格卡片 */
.app-price-card {
  flex: 1;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 32px 28px;
  min-width: 320px;
}

.price-header {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.price-symbol {
  font-size: 28px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
}

.price-number {
  font-size: 48px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -1px;
}

.price-sub {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.3);
  margin-bottom: 20px;
}

.btn-add-funds {
  width: 100%;
  padding: 14px 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 16px;
}

.btn-add-funds:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

.price-invite {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 215, 0, 0.06);
  border: 1px solid rgba(255, 215, 0, 0.1);
  border-radius: 12px;
  font-size: 14px;
  color: #ffd866;
  margin-bottom: 20px;
}

.invite-icon {
  font-size: 20px;
}

.price-crypto-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.crypto-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.crypto-item:hover {
  background: rgba(255, 255, 255, 0.03);
}

.crypto-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.crypto-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.crypto-change {
  font-size: 12px;
  font-weight: 600;
}

.change-up {
  color: #00c951;
}
.change-down {
  color: #ff6b6b;
}

.crypto-price {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  font-family: "SF Mono", monospace;
}

/* ============================================================
   🆕 结算动态标题（不吸底）
   ============================================================ */
.settlement-section {
  padding: 80px 20px 0 20px;
  background: #0a0e1a;
}

/* ============================================================
   🆕 合作钱包板块
   ============================================================ */
.wallets-section {
  padding: 80px 20px;
  background: #0a0e1a;
}

.wallets-grid {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
}

.wallet-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  transition: all 0.3s ease;
  position: relative;
  cursor: default;
  min-height: 100px;
}

.wallet-card:hover {
  transform: translateY(-4px);
  border-color: rgba(0, 180, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
}

.wallet-highlight {
  border-color: rgba(255, 215, 0, 0.2);
  background: rgba(255, 215, 0, 0.04);
}

.wallet-highlight:hover {
  border-color: rgba(255, 215, 0, 0.4);
  background: rgba(255, 215, 0, 0.08);
}

.wallet-icon {
  width: 70px;
  height: 70px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 8px;
  overflow: hidden;
}

.wallet-icon img {
  width: 70px;
  height: 70px;
  /* object-fit: contain; */
}

.wallet-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}

.wallet-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffd700, #f59e0b);
  color: #0a0e1a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ============================================================
   CTA 区
   ============================================================ */
.cta-section {
  padding: 80px 20px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0e1a, #1a1f35);
}

.cta-bg {
  position: absolute;
  inset: 0;
}

.cta-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.3;
}

.cta-orb-1 {
  width: 500px;
  height: 500px;
  background: #0066ff;
  top: -200px;
  right: -100px;
}

.cta-orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -200px;
  left: -100px;
}

.cta-content {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 16px;
}

.cta-title {
  font-size: 44px;
  font-weight: 800;
  margin: 0 0 16px 0;
}

.cta-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin: 0 0 32px 0;
}

.cta-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.btn-cta {
  padding: 16px 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 100, 255, 0.4);
}

.cta-note {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .nodes-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .app-download-container {
    flex-direction: column;
    text-align: center;
  }
  .app-qr-wrapper {
    justify-content: center;
  }
  .app-price-card {
    min-width: unset;
    width: 100%;
  }
  .wallets-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 40px;
  }
  .hero-subtitle {
    font-size: 18px;
  }
  .nodes-grid {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
  .cta-title {
    font-size: 32px;
  }
  .hero-stats {
    flex-wrap: wrap;
    gap: 16px;
  }
  .app-title {
    font-size: 32px;
  }
  .wallets-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .price-number {
    font-size: 36px;
  }
}

@media (max-width: 480px) {
  .nodes-grid {
    grid-template-columns: 1fr;
  }
  .hero-title {
    font-size: 32px;
  }
  .hero-actions {
    flex-direction: column;
    gap: 12px;
  }
  .stat-divider {
    display: none;
  }
  .hero-stats {
    gap: 16px;
  }
  .wallets-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .wallet-card {
    padding: 14px 8px;
    min-height: 80px;
  }
  .wallet-icon {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }
  .wallet-name {
    font-size: 11px;
  }
  .app-qr {
    width: 90px;
    height: 90px;
  }
}
</style>

<style>
/* ============================================================
   🆕 APP 应用下载板块（简洁版）
   ============================================================ */
.app-download-section {
  padding: 80px 20px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0e1a, #0d1a2b);
}

.app-download-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.app-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.15;
}

.app-orb-1 {
  width: 500px;
  height: 500px;
  background: #00b4ff;
  top: -200px;
  left: -100px;
}

.app-orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -150px;
  right: -100px;
}

.app-download-container {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

/* ===== 左侧文字 ===== */
.app-text {
  flex: 1;
}

.app-title {
  font-size: 44px;
  font-weight: 800;
  line-height: 1.2;
  margin: 12px 0 16px 0;
}

.app-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin-bottom: 32px;
}

.app-download-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.app-qr {
  width: 100px;
  height: 100px;
  background: #fff;
  border-radius: 16px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

.app-qr img {
  width: 100%;
  height: 100%;
  display: block;
}

.app-qr-text {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 8px;
}

.store-buttons {
  display: flex;
  gap: 12px;
}

.btn-store {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-store:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.btn-store svg {
  flex-shrink: 0;
}

/* ===== 右侧 App 截图 ===== */
.app-screenshot {
  flex: 0 0 300px;
  display: flex;
  justify-content: center;
}

.phone-mockup {
  position: relative;
  width: 280px;
  border-radius: 36px;
  background: #1a1f35;
  padding: 12px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.06);
}

.phone-mockup img {
  width: 100%;
  height: auto;
  border-radius: 24px;
  display: block;
}

/* 刘海装饰 */
.phone-notch {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 28px;
  background: #0a0e1a;
  border-radius: 0 0 16px 16px;
  z-index: 2;
}

.phone-notch::after {
  content: "";
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 6px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

/* ===== 响应式 ===== */
@media (max-width: 1024px) {
  .app-download-container {
    flex-direction: column;
    text-align: center;
  }
  .app-download-actions {
    justify-content: center;
    flex-wrap: wrap;
  }
  .app-screenshot {
    flex: unset;
  }
  .phone-mockup {
    width: 220px;
  }
}

@media (max-width: 768px) {
  .app-title {
    font-size: 32px;
  }
  .app-download-actions {
    flex-direction: column;
    align-items: center;
  }
  .store-buttons {
    flex-direction: column;
  }
  .phone-mockup {
    width: 200px;
    padding: 8px;
    border-radius: 28px;
  }
  .phone-mockup img {
    border-radius: 20px;
  }
  .phone-notch {
    width: 100px;
    height: 22px;
    top: 14px;
  }
  .phone-notch::after {
    width: 40px;
    height: 4px;
  }
}

@media (max-width: 480px) {
  .phone-mockup {
    width: 160px;
    padding: 6px;
    border-radius: 20px;
  }
  .phone-mockup img {
    border-radius: 14px;
  }
  .phone-notch {
    width: 80px;
    height: 16px;
    top: 10px;
  }
  .phone-notch::after {
    width: 30px;
    height: 3px;
    top: 4px;
  }
  .app-qr {
    width: 80px;
    height: 80px;
  }
}

.apptp {
  width: 480px;
}

.apptp img {
  width: 100%;
  height: auto;
  border-radius: 24px;
  display: block;
}

/* ============================================================
   机房建设板块
   ============================================================ */
.build-section {
  padding: 80px 20px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #080c18, #0f1a2e, #0a0e1a);
}

.build-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.build-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(140px);
  opacity: 0.12;
}

.build-orb-1 {
  width: 500px;
  height: 500px;
  background: #7c3aed;
  top: -200px;
  left: -100px;
}

.build-orb-2 {
  width: 400px;
  height: 400px;
  background: #00b4ff;
  bottom: -150px;
  right: -80px;
}

.build-orb-3 {
  width: 300px;
  height: 300px;
  background: #ffd700;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.05;
}

.build-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.build-content {
  display: flex;
  gap: 60px;
  align-items: stretch;
}

/* ===== 左侧文字 ===== */
.build-text {
  flex: 1.2;
}

.build-title {
  font-size: 44px;
  font-weight: 800;
  line-height: 1.2;
  margin: 12px 0 16px 0;
}

.build-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.8;
  margin-bottom: 32px;
}

.build-highlight-text {
  color: #ffd866;
  font-weight: 700;
  font-size: 20px;
}

/* 特性列表 */
.build-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;
  margin-bottom: 36px;
}

.build-feature {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.build-feature-icon {
  font-size: 28px;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.build-feature h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.build-feature p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.5;
  margin: 0;
}

.build-feature p strong {
  color: #ffd866;
}

/* ===== 右侧数据卡片 ===== */
.build-stats-card {
  flex: 0.8;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  transition: all 0.3s ease;
}

.build-stats-card:hover {
  border-color: rgba(0, 180, 255, 0.15);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.build-stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.build-stats-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.build-stats-update {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.04);
  padding: 2px 12px;
  border-radius: 12px;
}

.build-stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.build-stat-item:last-of-type {
  border-bottom: none;
}

.build-stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}

.build-stat-number {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  font-family: "SF Mono", "Courier New", monospace;
}

.build-stat-profit {
  color: #ffd866;
}

.build-stat-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.06),
    transparent
  );
  margin: 16px 0;
}

.build-cta-mini {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  background: rgba(0, 180, 255, 0.04);
  border: 1px solid rgba(0, 180, 255, 0.06);
  border-radius: 12px;
}

.build-cta-mini span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* ===== 按钮 ===== */
.btn-build {
  position: relative;
  padding: 16px 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #7c3aed, #4f46e5);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  overflow: hidden;
  letter-spacing: 1px;
}

.btn-build:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 40px rgba(124, 58, 237, 0.4);
}

.btn-build-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
}

.btn-build:hover .btn-build-glow {
  opacity: 1;
}

.btn-build-mini {
  padding: 8px 20px;
  border-radius: 8px;
  background: rgba(124, 58, 237, 0.2);
  color: #a78bfa;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(124, 58, 237, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  white-space: nowrap;
}

.btn-build-mini:hover {
  background: rgba(124, 58, 237, 0.3);
  border-color: rgba(124, 58, 237, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .build-content {
    flex-direction: column;
    gap: 40px;
  }

  .build-stats-card {
    flex: unset;
    min-width: unset;
  }

  .build-features {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .build-title {
    font-size: 32px;
  }

  .build-desc {
    font-size: 16px;
  }

  .build-features {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .build-stats-card {
    padding: 24px 20px;
  }

  .build-stat-number {
    font-size: 18px;
  }

  .build-cta-mini {
    flex-direction: column;
    text-align: center;
  }

  .btn-build {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .build-title {
    font-size: 26px;
  }

  .build-desc {
    font-size: 14px;
  }

  .build-feature-icon {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  .build-feature h4 {
    font-size: 14px;
  }

  .build-feature p {
    font-size: 13px;
  }

  .build-stats-card {
    padding: 18px 14px;
  }

  .build-stat-item {
    padding: 8px 0;
  }

  .build-stat-number {
    font-size: 16px;
  }

  .build-stat-label {
    font-size: 12px;
  }
}

/* ============================================================
   机房建设弹框
   ============================================================ */
.build-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.build-modal {
  position: relative;
  width: 380px;
  max-width: 90vw;
  background: linear-gradient(160deg, #1a1f35, #0f1a2e);
  border: 1px solid rgba(124, 58, 237, 0.2);
  border-radius: 20px;
  padding: 40px 32px 32px;
  text-align: center;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5), 0 0 40px rgba(124, 58, 237, 0.1);
  animation: modal-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.build-modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-family: inherit;
}

.build-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  transform: rotate(90deg);
}

.build-modal-icon {
  font-size: 56px;
  margin-bottom: 16px;
  animation: modal-bounce 2s ease-in-out infinite;
}

.build-modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 12px 0;
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.build-modal-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin: 0 0 28px 0;
}

.build-modal-btn {
  width: 100%;
  padding: 12px 0;
  border-radius: 10px;
  background: linear-gradient(135deg, #7c3aed, #4f46e5);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.build-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(124, 58, 237, 0.4);
}

/* 弹框动画 */
@keyframes modal-pop {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes modal-bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* 过渡动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .build-modal,
.modal-fade-leave-active .build-modal {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter .build-modal,
.modal-fade-leave-to .build-modal {
  transform: scale(0.8) translateY(20px);
  opacity: 0;
}

/* 响应式 */
@media (max-width: 480px) {
  .build-modal {
    width: 320px;
    padding: 32px 24px 24px;
  }

  .build-modal-icon {
    font-size: 44px;
  }

  .build-modal-title {
    font-size: 20px;
  }

  .build-modal-desc {
    font-size: 14px;
  }
}
</style>
